import type React from "react"

export const DepletionRateNavigationIcon = (props: React.ComponentProps<"svg">): JSX.Element => (
    <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        {...props}
    >
        <path
            d='M3 2a1 1 0 0 1 1 1h1a1 1 0 1 1 0 2H4v2h1a1 1 0 1 1 0 2H4v2h1a1 1 0 1 1 0 2H4v2h1a1 1 0 1 1 0 2H4v3h3v-1a1 1 0 1 1 2 0v1h2v-1a1 1 0 1 1 2 0v1h2v-1a1 1 0 1 1 2 0v1h2v-1a1 1 0 1 1 2 0v1a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1Z'
            fill='currentColor'
        />
        <path
            d='M20.923 14.77a1 1 0 0 0 1-1v-9a1 1 0 1 0-2 0v6.585L11.63 3.062a1 1 0 1 0-1.414 1.414l8.293 8.293h-6.586a1 1 0 1 0 0 2h9Z'
            fill='currentColor'
        />
    </svg>
)
